__turbopack_context__.v({
  "default": "ui-search-icon-module__8ketOW__default",
  "icon": "ui-search-icon-module__8ketOW__icon",
  "sky": "ui-search-icon-module__8ketOW__sky",
});
